import dayjs from 'dayjs';
import LocalizedFormat from 'dayjs/plugin/localizedFormat';
/** @TODO - improve this so we don't have to pre-import the locales */
import 'dayjs/locale/es';
import 'dayjs/locale/de';
import 'dayjs/locale/fr';
import { log } from '../log';
/**
 * set dayjs locale here b/c well…it works and i'm having a day
 * @see: https://day.js.org/docs/en/i18n/loading-into-nodejs
 * locale formats from webGUI don't match
 * dayjs requires – 'de' not 'de_DE'
*/
const upcWC = document.getElementsByTagName('unraid-user-profile')[0];
if (upcWC) {
  const shortLocale = upcWC.getAttribute('locale').slice(0, 2);
  dayjs.locale(shortLocale);
  log.debug('[formatDate] dayjs.locale()', dayjs.locale());
}

dayjs.extend(LocalizedFormat);

const formatDate = date => dayjs(parseInt(date, 10)).format('llll');

export default formatDate;
